import styled, { css } from 'styled-components';

import { TextButton } from '@xing-com/button';
import { xdlColorTextSecondary, spaceXS } from '@xing-com/tokens';

import type { CommentCounterProps } from './comment-counter';

// *** Base ***
const baseCommentCounter = css`
  color: ${xdlColorTextSecondary} !important;
`;

// *** Components ***
const CommentCounter = styled(TextButton)<CommentCounterProps>`
  ${baseCommentCounter};
  ${({ compact }) =>
    compact &&
    css`
      > div span:nth-child(1) {
        margin-right: ${spaceXS};
      }
    `};
`;

export const Styled = {
  CommentCounter,
};
